function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: `application/${type}` },
  };
}
const trapFocusHandlers = {};
function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}
function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}
function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (event.target !== container && event.target !== last && event.target !== first) return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if ((event.target === container || event.target === first) && event.shiftKey) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();

  if (
    elementToFocus.tagName === 'INPUT' &&
    ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
    elementToFocus.value
  ) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}
class DartDrawerOpener extends HTMLElement {
	constructor() {
	  super();
    this.addEventListener('click',function(){
      document.querySelector('cart-drawer').open();
    })
  }
}
customElements.define('cart-drawer-opener', DartDrawerOpener);

class CartRemoveButton extends HTMLElement {
	constructor() {
	  super();
  this.loadingSpinner= this.closest('.cart-item').querySelector('.loading-spinner');
  this.cartItemsPrice=this.closest('.cart-item').querySelector('.cart-item__price-wrapper');
	  this.addEventListener("click", (event) => {
		event.preventDefault();
    this.loadingSpinner.classList.remove('hidden')
    this.cartItemsPrice.classList.add('hidden');
		this.removeItems(event.target.closest('cart-remove-button'));
	  });
	}
	removeItems(product) {
	  const updates = {};
	  updates[product.getAttribute("data-product-id")] = 0;
	 const heatSensetiveProducts=document.querySelectorAll('cart-remove-button[data-heat-sensitive="true"]');
  if(heatSensetiveProducts.length===1 && product.getAttribute('data-heat-sensitive')==="true")
  {
    updates[29360514498632] = 0;
  }
	 
	  const body = JSON.stringify({
		  updates,
		  sections: this.getSectionsToRender().map(section => section.section),
		  sections_url: window.location.pathname,
	  });
  
	  fetch(window.Shopify.routes.root + "cart/update.js", {
		  method: "POST",
		  headers: {
			  "Content-Type": "application/json",
		  },
		  body: body
	  })
	  .then((response) => response.json())
	  .then((cart) => {
		  this.getSectionsToRender().forEach((section) => {
			  const elementToReplace =
				  document.getElementById(section.id)?.querySelector(section.selector) ||
				  document.getElementById(section.id);
			  if (elementToReplace) {
				  fetch(`${window.location.pathname}?section_id=${section.section}`)
					  .then((response) => response.text())
					  .then((responseText) => {
						  const html = new DOMParser().parseFromString(responseText, "text/html");
						  const sourceElement = html.querySelector(section.selector) || html.getElementById(section.id);
						  if (sourceElement) {
							  elementToReplace.innerHTML = sourceElement.innerHTML;
							  const cartDrawer = document.querySelector('cart-drawer');
							  if (cartDrawer) {
								  cartDrawer.classList.toggle('is-empty', cart.item_count === 0);
							  }
							  if (section.id === "main-cart-footer") {
								  const cartFooter = document.getElementById("main-cart-footer");
								  if (cartFooter) {
									  cartFooter.classList.toggle("is-empty", cart.item_count === 0);
								  }
							  }
						  }
					  });
			  }
		  });
		 
	  })
	  .catch((error) => {
		  console.error("Error:", error);
	  })
    .finally(()=>{
      this.loadingSpinner.classList.add('hidden');
      this.cartItemsPrice.classList.remove('hidden');

    })
  }
  getSectionsToRender() {
	const mainCartItems = document.getElementById("main-cart-items");
	const mainCartFooter = document.getElementById("main-cart-footer");
	return [
	  {
		id: "main-cart-items",
		section: mainCartItems?.dataset?.id || "main-cart-items",
		selector: ".js-contents",
	  },
	  {
		id: "cart-icon-bubble",
		section: "cart-icon-bubble",
		selector: ".shopify-section",
	  },
	  {
		id: "cart-live-region-text",
		section: "cart-live-region-text",
		selector: ".shopify-section",
	  },
	  {
		id: "main-cart-footer",
		section: mainCartFooter?.dataset?.id || "main-cart-footer",
		selector: ".js-contents",
	  },
    {
      id: 'HeaderCartIcons',
      section: 'header-cart-icons',
      selector: 'cart-drawer-opener',
    },
	  {
		id: "CartDrawer",
		section: "cart-drawer",
		selector: ".drawer__inner",
	  }
	];
  }
  }

customElements.define('cart-remove-button', CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();
    
    this.lineItemStatusElement =
      document.getElementById('shopping-cart-line-item-status') || document.getElementById('CartDrawer-LineItemStatus');

    const debouncedOnChange = this.debounce((event) => {
      this.onChange(event);
    }, ON_CHANGE_DEBOUNCE_TIMER);

    this.addEventListener('change', debouncedOnChange.bind(this));
  }
  cartUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (event.source === 'cart-items') {
        return;
      }
      return this.onCartUpdate();
    });
  }
 debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}
  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }

  resetQuantityInput(id) {
    console.log(id)
    const input = this.querySelector(`#Quantity-${id}`);
    input.value = input.getAttribute('value');
    this.isEnterPressed = false;
  }

  // setValidity(event, index, message) {
  //   event.target.setCustomValidity(message);
  //   event.target.reportValidity();
  //   this.resetQuantityInput(index);
  //   event.target.select();
  // }

  validateQuantity(event) {
    const inputValue = parseInt(event.target.value);
    const index = event.target.dataset.index;
    let message = '';

    if (inputValue < event.target.dataset.min) {
      message = window.quickOrderListStrings.min_error.replace('[min]', event.target.dataset.min);
    } else if (inputValue > parseInt(event.target.max)) {
      message = window.quickOrderListStrings.max_error.replace('[max]', event.target.max);
    } else if (inputValue % parseInt(event.target.step) !== 0) {
      message = window.quickOrderListStrings.step_error.replace('[step]', event.target.step);
    }

    if (message) {
      // this.setValidity(event, index, message);
    } else {
      event.target.setCustomValidity('');
      event.target.reportValidity();
      this.updateQuantity(
        index,
        inputValue,
        event,
        document.activeElement.getAttribute('name'),
        event.target.dataset.quantityVariantId
      );
    }
  }

  onChange(event) {
    this.validateQuantity(event);
  }

  onCartUpdate() {
    if (this.tagName === 'CART-DRAWER-ITEMS') {
      return fetch(`${Theme.routes.cart_url}?section_id=cart-drawer`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const selectors = ['cart-drawer-items', '.cart-drawer__footer'];
          for (const selector of selectors) {
            const targetElement = document.querySelector(selector);
            const sourceElement = html.querySelector(selector);
            if (targetElement && sourceElement) {
              targetElement.replaceWith(sourceElement);
            }
          }
        })
        .catch((e) => {
          console.error(e);
        });
    } else {
      return fetch(`${Theme.routes.cart_url}?section_id=main-cart-items`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const sourceQty = html.querySelector('cart-items');
          this.innerHTML = sourceQty.innerHTML;
        })
        .catch((e) => {
          console.error(e);
        });
    }
  }

  getSectionsToRender() {
    const mainCartItems = document.getElementById("main-cart-items");
    const mainCartFooter = document.getElementById("main-cart-footer");
    return [
      {
      id: "main-cart-items",
      section: mainCartItems?.dataset?.id || "main-cart-items",
      selector: ".js-contents",
      },
      {
      id: "cart-icon-bubble",
      section: "cart-icon-bubble",
      selector: ".shopify-section",
      },
      {
      id: "cart-live-region-text",
      section: "cart-live-region-text",
      selector: ".shopify-section",
      },
      {
      id: "main-cart-footer",
      section: mainCartFooter?.dataset?.id || "main-cart-footer",
      selector: ".js-contents",
      },
      {
        id: 'HeaderCartIcons',
        section: 'header-cart-icons',
        selector: 'cart-drawer-opener',
      },
      {
      id: "CartDrawer",
      section: "cart-drawer",
      selector: ".drawer__inner",
      }
    ];
    }

  updateQuantity(line, quantity, event, name, variantId) {
    this.enableLoading(line);
    const loading__spinner=event.target.closest('.cart-item').querySelector('.loading-spinner')
    const cartItemsPrice=event.target.closest('.cart-item').querySelector('.cart-item__price-wrapper')

    loading__spinner.classList.remove('hidden')
    cartItemsPrice.classList.add('hidden')
    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });
    const eventTarget = event.currentTarget instanceof CartRemoveButton ? 'clear' : 'change';

    fetch(`${Theme.routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => response.json())
      .then((parsedState) => {
        // CartPerformance.measure(`${eventTarget}:paint-updated-sections"`, () => {
          const quantityElement =
            document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);
          const items = document.querySelectorAll('.cart-item');

          if (parsedState.errors) {
            quantityElement.value = quantityElement.getAttribute('value');
            this.updateLiveRegions(line, parsedState.errors);
            return;
          }

          this.classList.toggle('is-empty', parsedState.item_count === 0);
          const cartDrawerWrapper = document.querySelector('cart-drawer');
          const cartFooter = document.getElementById('main-cart-footer');

          if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
          if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);

          this.getSectionsToRender().forEach((section) => {
            if(section)
            {
              const elementToReplace =
              document.getElementById(section.id)?.querySelector(section.selector) || document.getElementById(section.id);
            elementToReplace.innerHTML = this.getSectionInnerHTML(
              parsedState.sections[section.section],
              section.selector
            );
          }
          });
          const updatedValue = parsedState.items[line - 1] ? parsedState.items[line - 1].quantity : undefined;
          let message = '';
          if (items.length === parsedState.items.length && updatedValue !== parseInt(quantityElement.value)) {
            if (typeof updatedValue === 'undefined') {
              message = window.cartStrings.error;
            } else {
              message = window.cartStrings.quantityError.replace('[quantity]', updatedValue);
            }
          }
          this.updateLiveRegions(line, message);

          const lineItem =
            document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
          if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
            cartDrawerWrapper
              ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`))
              : lineItem.querySelector(`[name="${name}"]`).focus();
          } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
            trapFocus(cartDrawerWrapper.querySelector('.drawer__inner-empty'), cartDrawerWrapper.querySelector('a'));
          } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
            trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'));
          }
        // });

        // CartPerformance.measureFromEvent(`${eventTarget}:user-action`, event);

        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: parsedState, variantId: variantId });
      })
      .catch((err) => {
        console.log(err)
        this.querySelectorAll('.loading__spinner').forEach((overlay) => overlay.classList.add('hidden'));
        const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
        errors.textContent = window.cartStrings.error;
      })
      .finally(() => {
        this.disableLoading(line);
        loading__spinner.classList.add('hidden')
        cartItemsPrice.classList.remove('hidden')
      });
  }

  updateLiveRegions(line, message) {
    const lineItemError =
      document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
    if (lineItemError) lineItemError.querySelector('.cart-item__error-text').textContent = message;

    this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus =
      document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');
    cartStatus.setAttribute('aria-hidden', false);

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.add('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading__spinner`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner`);

    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) => overlay.classList.remove('hidden'));

    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.remove('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading__spinner`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner`);

    cartItemElements.forEach((overlay) => overlay.classList.add('hidden'));
    cartDrawerItemElements.forEach((overlay) => overlay.classList.add('hidden'));
  }
}

customElements.define('cart-items', CartItems);

if (!customElements.get('cart-note')) {
  customElements.define(
    'cart-note',
    class CartNote extends HTMLElement {
      constructor() {
        super();

        this.addEventListener(
          'input',
          this.debounce((event) => {
            const body = JSON.stringify({ note: event.target.value });
            fetch(`${Theme.routes.cart_update_url}`, { ...fetchConfig(), ...{ body } })
            .then(() => {
              // CartPerformance.measureFromEvent('note-update:user-action', event)
            });
          }, ON_CHANGE_DEBOUNCE_TIMER)
        );
      }
    }
  );
}
